import { render, staticRenderFns } from "./AddressTH.vue?vue&type=template&id=aaaecae4&"
import script from "./AddressTH.vue?vue&type=script&lang=js&"
export * from "./AddressTH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports